export default {
    state: {
        searchSelectedPlace: null,
        searchSelectedAnalogyPlace: null,
    },
    actions: {},
    mutations: {
        PLACE_SEARCH_SELECTED_PLACE: function (state, val) {
            state.searchSelectedPlace = val;
        },
        PLACE_SEARCH_SELECTED_ANALOGY_PLACE: function (state, val) {
            state.searchSelectedAnalogyPlace = val;
        },
    },
    getters: {}
};
